export default function initCustomPriceDropdown (containerSelector = '#prices') {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    const dropdown = container.querySelector('.state-dropdown');
    if (!dropdown) return;

    const toggle = dropdown.querySelector('.dropdown-toggle');
    const menu = dropdown.querySelector('.dropdown-menu');
    const selected = dropdown.querySelector('[data-selected]');

    const switchWrap = container.querySelector('.packages__switchWrap');
    const priceToggle = container.querySelector('#priceToggle');
    const priceBlocks = [...container.querySelectorAll('.packages__cardPrice')];

    const startWithCarePass = document.querySelector('#StartWithCarePass');

    const currency = (n) => `$${Number(n).toFixed(2)}`;
    const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();

    const setVisible = (isVisible) => {
        if (switchWrap) switchWrap.style.display = isVisible ? 'flex' : 'none';
        priceBlocks.forEach(el => { el.style.display = isVisible ? 'flex' : 'none'; });
    };

    const applyVeteranPrices = (isVeteran) => {
        priceBlocks.forEach(block => {
            block.classList.toggle('veteran-active', isVeteran);
        });
    };

    const readPrice = (block, type, state) => {
        const key = `price${type}${cap(state)}`;
        const raw = block.dataset[key];
        return raw != null && raw !== '' ? Number(raw) : null;
    };

    const setPricesForState = (stateKey) => {
        priceBlocks.forEach((block) => {
            const stdEl = block.querySelector('.standard-price');
            const vetEl = block.querySelector('.veteran-price');

            const std = readPrice(block, 'Standard', stateKey);
            const vet = readPrice(block, 'Veteran', stateKey);

            if (stdEl && std != null) stdEl.textContent = currency(std);
            if (vetEl && vet != null) vetEl.textContent = currency(vet);
        });
    };

    setVisible(false);
    applyVeteranPrices(false);
    if (priceToggle) priceToggle.checked = false;

    let selectedValue = '';

    toggle.addEventListener('click', (e) => {
        e.stopPropagation();
        dropdown.classList.toggle('open');
        menu.style.display = dropdown.classList.contains('open') ? 'block' : 'none';
    });

    menu.querySelectorAll('li').forEach((item) => {
        item.addEventListener('click', () => {
            selectedValue = (item.getAttribute('data-value') || '').toLowerCase();
            selected.textContent = item.textContent;

            const isSupportedState = ['florida', 'pennsylvania'].includes(selectedValue);

            setVisible(isSupportedState);

            if (priceToggle) priceToggle.checked = false;
            applyVeteranPrices(false);

            if (isSupportedState) setPricesForState(selectedValue);

            dropdown.classList.remove('open');
            menu.style.display = 'none';
        });
    });

    document.addEventListener('click', (e) => {
        if (!dropdown.contains(e.target)) {
            dropdown.classList.remove('open');
            menu.style.display = 'none';
        }
    });

    if (priceToggle) {
        priceToggle.addEventListener('change', (e) => {
            applyVeteranPrices(e.target.checked);
        });
    }

    // Handle Care Pass button click
    if (startWithCarePass) {
        startWithCarePass.addEventListener('click', () => {            
            if (!selectedValue) {
                const url = `/appointment/start`;
                window.location.href = url;
            } else {
                const url = `/appointment/start?state=${selectedValue}`;
                window.location.href = url;
            }
        });
    }

    return () => selectedValue;
}